import styled from "styled-components";

export const MyTextArea = styled.textarea`
  width: 100%;
  border: 1px solid #9d9d9d;
  resize: none;
  outline: none;
  padding: 10px;
  height: 100%;
  border-radius: 10px;

  font-family: Mulish;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 16px;

  &:disabled {
    background-color: transparent;
    color: #9d9d9d;
  }
`;

export const Label = styled.label`
  display: block;
  position: relative;

  > span {
    color: #9d9d9d;
    font-family: Mulish;
    display: block;
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: 12px;
    letter-spacing: 0.018px;
    position: absolute;
    top: -6px;
    left: 16px;
    background-color: #fff;
    padding: 0 5px;
  }
`;
